import { BASE_URL } from "../API/Constants";

export const getImageUrl = (img) => {
  if (!img) return "";
  let path = typeof img === 'string' ? img : (img.url || img.path || "");
  if (!path) return "";
  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  // Clean leading slash
  let cleanPath = path.startsWith('/') ? path.substring(1) : path;

  // Replace internal Laravel storage paths with public web storage path
  if (cleanPath.startsWith('storage/app/public/')) {
    cleanPath = cleanPath.replace('storage/app/public/', 'storage/');
  } else if (cleanPath.startsWith('app/public/')) {
    cleanPath = cleanPath.replace('app/public/', 'storage/');
  } else if (!cleanPath.startsWith('storage/')) {
    cleanPath = `storage/${cleanPath}`;
  }

  const baseUrl = BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`;
  return `${baseUrl}${cleanPath}`;
};
